import styled from 'styled-components';

export const RadioWithLogoLabel = styled.div<{}>(({ theme }) => {
  return `
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 22px 20px;
    border-radius: 4px;
    border: solid 2px #00a7e1;
    background-color: #ffffff;
    cursor: pointer;
`;
});

export const RadioWithLogoImgLogo = styled.img<{}>(({ theme }) => {
  return `
  width: 72px;
  height: 20px;
  margin-left: ${theme.spacing.medium}px
`;
});
